import { workspaceAccessConfig } from './workspace-access';

const LOGIN_OPTIONAL_TOOL_ID = 'img-fast-upscale';

export function requiresWorkspaceLoginToGenerate(toolId: string) {
  return (
    workspaceAccessConfig.requireLoginToGenerate &&
    toolId !== LOGIN_OPTIONAL_TOOL_ID
  );
}
